<style scoped>
    .search >>> .ivu-input{width: 348px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
    .approval >>> .ivu-btn{width: 130px;border-radius: 36px;}
    .approval-list-tab{text-align: center;color: #333333;font-size: 14px;font-weight: bold;line-height: 62px;border-bottom: 1px solid #d7dde4;}
    .approval-list{text-align: center;color: #464c5b;font-size: 14px;line-height: 95px;border-bottom: 1px solid #d7dde4;}
    .account{width: 80px;height: 35px;border-radius: 18px;}
    .notice-background{background: url("/img/sys/bg7.png");height: 140px;}

</style>

<template>
  <div>
    <!--    提成-->
    <Modal
        v-model="edit.panel"
        title="录入提成数据"
        @on-ok="saveState()"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">案号：</Col>
        <Col span="16"><Input v-model="edit.caseNumber" placeholder="输入案号"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">委托人：</Col>
        <Col span="16"><Input v-model="edit.clientName" placeholder="输入委托人"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">到账金额：</Col>
        <Col span="16"><Input v-model="edit.amount" placeholder="输入到账金额"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">合同是否签返：</Col>
        <Col span="16"><Input v-model="edit.contractState" placeholder="合同签返状态"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">发票是否开具：</Col>
        <Col span="16"><Input v-model="edit.invoiceState" placeholder="发票开具状态"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">提成比例：</Col>
        <Col span="6"><Input v-model="edit.proportion" @on-change="parseInt(edit.royaltyAmount = edit.proportion*edit.amount/100)" placeholder="提成比例"></Input></Col>
        <Col span="10"> %</Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">提成总额：</Col>
        <Col span="16"><Input v-model="edit.royaltyAmount" placeholder="自动计算总额"></Input></Col>
      </Row>
      <!--<Row type="flex" align="top" style="padding: 10px 0" v-if="projectUser.length>0">-->
        <!--<Col span="6" style="text-align: right;line-height:32px;">提成分配：<br/>（可直接填写金额）</Col>-->
        <!--<Col span="16">-->
          <!--<Row v-for="(item,index) in edit.royalty" type="flex" align="middle">-->
            <!--<Col span="6" style="text-align: right">-->
              <!--{{projectUser.find((secItem)=>{return secItem.id==item.id}).name}}：-->
            <!--</Col>-->
            <!--<Col span="18">-->
              <!--<Input v-model="item.proportion" @on-change="item.amount=parseInt(edit.royaltyAmount*item.proportion/100)" style="width:50px;text-align: center" placeholder="比例"></Input>%-->
              <!--=-->
              <!--<Input v-model="item.amount" style="width:100px" placeholder="金额"></Input>￥-->
            <!--</Col>-->
            <!--<div style="padding: 5px;"></div>-->
          <!--</Row>-->
        <!--</Col>-->
      <!--</Row>-->
    </Modal>
    <!--    对账-->
    <Modal
        v-model="reconciliation.panel"
        title="录入对账数据"
        @on-ok="saveState()"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">案号：</Col>
        <Col span="16"><Input v-model="reconciliation.caseNumber" placeholder="输入案号"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">委托人：</Col>
        <Col span="16"><Input v-model="reconciliation.clientName" placeholder="输入委托人"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款人：</Col>
        <Col span="16"><Input v-model="reconciliation.payName" placeholder="输入付款人"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款金额：</Col>
        <Col span="16"><Input v-model="reconciliation.amount" placeholder="输入付款金额"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款时间：</Col>
        <Col span="16">
          <DatePicker type="date" @on-change="reconciliation.payDate = $event" placeholder="请选择日期" style="width: 200px"></DatePicker>
        </Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款方式：</Col>
        <Col span="16">
          <Select style="width:200px" v-model="reconciliation.payType" filterable placeholder="选择收费方式">
            <Option value="现金">现金</Option>
            <Option value="转账">转账</Option>
            <Option value="刷卡">刷卡</Option>
            <Option value="其他">其他</Option>
          </Select>
        </Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款凭证：</Col>
        <Col span="16">
          <Upload
              :show-upload-list="false"
              :on-success="uploadSuccess"
              style="display: inline-block;vertical-align:middle"
              :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
              :data="{MenuId:menuId,UserId:userId}"
              :action="getServerURL('default',true)">
            <Button
                icon="ios-cloud-upload-outline"
                :type="reconciliation.file.name?'success':'primary'"
            >
              {{reconciliation.file.name||'请选择文件'}}
            </Button>
          </Upload>
        </Col>
      </Row>
    </Modal>
    <!--    开票-->
    <Modal
        v-model="invoice.panel"
        title="录入开票数据"
        @on-ok="saveState()"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">案号：</Col>
        <Col span="16"><Input v-model="invoice.caseNumber" placeholder="输入案号"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">委托人：</Col>
        <Col span="16"><Input v-model="invoice.clientName" placeholder="输入委托人"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">开票对象：</Col>
        <Col span="16"><Input v-model="invoice.invoiceName" placeholder="输入开票对象"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">税号：</Col>
        <Col span="16"><Input v-model="invoice.taxNum" placeholder="输入税号"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">附件上传：</Col>
        <Col span="16">
          <Upload
              :show-upload-list="false"
              :on-success="uploadSuccessInvoice"
              style="display: inline-block;vertical-align:middle"
              :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
              :data="{MenuId:menuId,UserId:userId}"
              :action="getServerURL('default',true)">
            <Button
                icon="ios-cloud-upload-outline"
                :type="invoice.file.name?'success':'primary'"
            >
              {{reconciliation.file.name||'请选择文件'}}
            </Button>
          </Upload>
        </Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">开票金额：</Col>
        <Col span="16"><Input v-model="invoice.invoiceAmount" placeholder="开票金额"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">是否到账：</Col>
        <Col span="16">
          <Input v-model="invoice.payState" placeholder="资金到账状态"></Input>
        </Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">合同是否签返：</Col>
        <Col span="16"><Input v-model="invoice.contractState" placeholder="合同签返状态"></Input></Col>
      </Row>
    </Modal>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
  <div style="background-color: white">
    <!--<Modal-->
        <!--v-model="edit.panel"-->
        <!--title="录入收款数据"-->
        <!--@on-ok="saveState()"-->
        <!--ok-text="保存"-->
    <!--&gt;-->
      <!--<Row type="flex" align="middle" style="padding: 20px 0">-->
        <!--<Col span="6" style="text-align: right">收款金额：</Col>-->
        <!--<Col span="16"><Input v-model="edit.amount" placeholder="输入收款金额"></Input></Col>-->
      <!--</Row>-->
      <!--<Row type="flex" align="middle" style="padding: 20px 0">-->
        <!--<Col span="6" style="text-align: right">所属项目：</Col>-->
        <!--<Col span="16">-->
          <!--<Select v-model="edit.projectId">-->
            <!--<Option v-for="(item,index) in projectList" :value="item.id">{{item.name}}</Option>-->
          <!--</Select>-->
        <!--</Col>-->
      <!--</Row>-->
      <!--<Row type="flex" align="middle" style="padding: 20px 0">-->
        <!--<Col span="6" style="text-align: right">资金状态：</Col>-->
        <!--<Col span="16">-->
          <!--<Select v-model="edit.amountState">-->
            <!--<Option v-for="(item,index) in trackingStateList" :value="item.value">{{item.name}}</Option>-->
          <!--</Select>-->
        <!--</Col>-->
      <!--</Row>-->
    <!--</Modal>-->
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="4" style="height: 100px;display: flex;align-items: center;text-align: center;">
        <Col span="24" style="line-height: 24px;border-right: 1px solid #d7dde4;">
          <p style="color: #2d8cf0;font-size: 24px">{{totalAmount}}</p>
          <p style="color: #999">合同金额</p>
        </Col>
      </Col>
      <Col span="4" style="height: 100px;display: flex;align-items: center;text-align: center;">
        <Col span="24" style="line-height: 24px;border-right: 1px solid #d7dde4;">
          <p style="color: #2d8cf0;font-size: 24px">{{paymented}}</p>
          <p style="color: #999">已收金额</p>
        </Col>
      </Col>
      <Col span="4" style="height: 100px;display: flex;align-items: center;text-align: center;">
        <Col span="24" style="line-height: 24px;">
          <p style="color: #2d8cf0;font-size: 24px">{{unPaid}}</p>
          <p style="color: #999">待收金额</p>
        </Col>
      </Col>
      <Col span="6" style="height: 100px;display: flex;align-items: center;text-align: center;">
        &nbsp;
      </Col>
      <Col span="6" style="height: 100px;display: flex;align-items: center;text-align: center;">
        <!--<Col span="24" style="line-height: 24px;">-->
          <!--<Button @click="reconciliationState()" type="warning" shape="circle" style="width:80px;height: 36px;font-size: 14px;color: #f9f9f9">对账</Button>-->
          <!--<span style="padding: 5px"></span>-->
          <!--<Button @click="invoiceState()" type="primary" shape="circle" style="width:80px;height: 36px;font-size: 14px;color: #f9f9f9">开票</Button>-->
          <!--<span style="padding: 5px"></span>-->
          <!--<Button @click="editState()" type="success" shape="circle" style="width:80px;height: 36px;font-size: 14px;color: #f9f9f9">提成</Button>-->
          <!--&lt;!&ndash;<Button @click="edit.panel = true;edit.amount = '';edit.projectId = '';edit.amountState = '';" icon="md-add" type="error" style="font-size:14px">添加到账金额</Button>&ndash;&gt;-->
        <!--</Col>-->
      </Col>
    </Row>
    <Menu mode="horizontal" :active-name=type.toString() @on-select="type=$event">
      <MenuItem name="1">
        对账列表
      </MenuItem>
      <MenuItem name="2">
        开票列表
      </MenuItem>
      <MenuItem name="3">
        提成列表
      </MenuItem>
    </Menu>
    <!---->
    <Row class="approval-list-tab">
      <Col span="3">收款金额</Col>
      <Col span="6">所属项目</Col>
      <Col span="3">发起时间</Col>
      <Col span="3">确认时间</Col>
      <Col span="3">确认金额</Col>
      <Col span="3">流水状态</Col>
      <Col span="3">操作</Col>
    </Row>
    <Row class="approval-list" v-for="(item,index) in trackingList">
      <Col span="3">￥{{item.amount||'--'}}</Col>
      <Col span="6">{{item.projectName||'--'}}</Col>
      <Col span="3">{{item.createTime||'--'}}</Col>
      <Col span="3">{{item.affirmatoryTime||'--'}}</Col>
      <Col span="3">{{item.affirmatoryAmount ||'--'}}</Col>
      <Col span="3">{{trackingStateList.find((secItem)=>{return secItem.value==item.state}).name||'--'}}</Col>
      <Col span="3">
        <Button v-if="item.state==true" :disabled="true" type="primary" style="padding: 0;line-height: 19px;" class="account" @click="confirmedTracking(item.id)">已确认</Button>
        <Button v-else type="success" style="padding: 0;line-height: 19px;" class="account" @click="confirmedTracking(item.id)">确认到账</Button>
      </Col>
    </Row>
  </div>
  </div>
</template>

<script>
  export default {
    name: "tracking",//资金跟踪
    data:function(){
      return{
        amount:{
          caseNumber:'',
          clientName:'',
          contractState:'',
          invoiceState:'',
          sum:0,
          received:0,
          notReceived:0,
          royalty:0,
        },
        reconciliation:{
          panel:false,
          payType:'',
          caseNumber:'',
          clientName:'',
          payName:'',
          amount:'',
          payDate:'',
          file:{
            name:'',
            src:'',
          },
        },
        invoice:{
          panel:false,
          invoiceName:'',
          caseNumber:'',
          clientName:'',
          taxNum:'',
          invoiceAmount:'',
          payState:'',
          contractState:'',
          file:{
            name:'',
            src:'',
          },
        },
        type:1,
        totalAmount:'',
        unPaid:'',
        paymented:'',
        trackingStateList:[],
        edit:{
          panel:false,
          amount:'',
          amountState:'',
          projectId:'',
        },
        projectList:[],
        trackingList:[],
      }
    },
    watch:{
      'type':function () {
        this.getTrackingList()
      }
    },
    methods:{
      uploadSuccess:function (response,file,fileList) {
        this.reconciliation.file.name = response.Data.name
        this.reconciliation.file.src = response.Data.path
        this.$Notice.success({
          title:'系统提示',
          desc:'文件上传成功！'
        })
      },

      uploadSuccessInvoice:function (response,file,fileList) {
        this.invoice.file.name = response.Data.name
        this.invoice.file.src = response.Data.path
        this.$Notice.success({
          title:'系统提示',
          desc:'文件上传成功！'
        })
      },
      //保存资金状态
      saveState:function(){
        var _this = this
        _this.send({
          headers:'D/AddTracking',
          data:{
            ProceedsCount:_this.edit.amount,
            CaseId:_this.edit.projectId,
            ProceedsResultsId:_this.edit.amountState,
          },
          success:function () {
            _this.getTrackingList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'记录添加成功！',
            })
          }
        })
      },
      //获取项目列表
      getProjcetList:function(){
        var _this = this
        _this.projcetList = []
        _this.send({
          headers:'D/CaseIn',
          warningTips:false,
          success:function (res) {
            for(var index in res){
              _this.projectList.push({
                id:res[index].CaseId,
                name:res[index].CaseTitle
              })
            }
          }
        })
      },
      //获取到账状态列表
      getTrackingStateList:function(){
        var _this = this
        _this.trackingStateList = []
        _this.send({
          headers:'D/PayStatus',
          warningTips:false,
          success:function (res) {
            for(var index in res){
              _this.trackingStateList.push({
                value:res[index].ProceedsResultsId,
                name:res[index].ProceedsResultsTitle,
              })
            }
            _this.getTrackingList()
          }
        })
      },
      //确认到账
      confirmedTracking:function(id){
        var _this = this
        _this.send({
          headers:'D/verify',
          confirm:true,
          data:{
            ProceedsId:id
          },
          success: function (res) {
            _this.getTrackingList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'确认到账成功！',
            })
          }
        })
      },
      //获取流水列表
      getTrackingList:function () {
        var _this = this
        _this.trackingList = []
        _this.send({
          headers:'D/ShowTracking',
          data:{
            ProceedsTypeId:_this.type,
          },
          success:function (res) {
            _this.totalAmount = res.SumMoney
            _this.unPaid = res.RemainPay
            _this.paymented = res.YetPay
            for(var index in res.list){
              _this.trackingList.push({
                id:res.list[index].ProceedsId,
                projectName:res.list[index].CaseTitle,
                createTime:res.list[index].ProceedsCreatedTime,
                affirmatoryTime:res.list[index].ProceedsEndTime,
                amount:res.list[index].ProceedsCount,
                state:res.list[index].ProceedsResultsId,
              })
            }
          }
        })
      },
      //对账
      reconciliationState:function(){
        //   {"name":"approvalInput","content":{"title":"申请人","text":tempClientName.toString()}},
        //   {"name":"approvalInput","content":{"title":"住所","text":tempClientAddress[0]}},
        //   {"name":"approvalInput","content":{"title":"联系人","text":_this.content.contactName}},
        //   {"name":"approvalInput","content":{"title":"联系方式","text":_this.content.contactMobile}},
        //   {"name":"approvalInput","content":{"title":"对方当事人","text":tempOpposedName.toString()}},
        //   // {"name":"approvalInput","content":{"title":"第三人","text":null}},
        //   {"name":"approvalInput","content":{"title":"案由","text":_this.content.cause}},
        //   {"name":"approvalInput","content":{"title":"委托人","text":tempClientName.toString()}},
        //   {"name":"approvalInput","content":{"title":"主办律师","text":tempManageName.toString()}},
        //   {"name":"approvalInput","content":{"title":"受理机关","text":_this.content.receivingUnitText}},
        //   {"name":"approvalInput","content":{"title":"审级或阶段","text":_this.content.caseStage}},
        //   {"name":"approvalInput","content":{"title":"争议标的额","text":_this.content.casetAmount}},
        //   {"name":"approvalInput","content":{"title":"收费比例/金额","text":_this.content.projectAmount}},
        //   {"name":"approvalInput","content":{"title":"收费方式","text":_this.payTypeList.find((secItem)=>{return secItem.id==_this.content.payType}).name}},
        //   {"name":"approvalInput","content":{"title":"结算方式","text":_this.content.settlementMethod}},
        //   {"name":"approvalTextarea","content":{"title":"简要案情","text":_this.content.caseDetails}}
        // var tempClientName = []
        // var tempClientAddress = []
        // var tempOpposedName = []
        // for(var i=0;i<this.client.length;i++){
        //   tempClientName.push(this.client[i].name,)
        //   tempClientAddress.push(this.client[i].address,)
        // }
        // for(var i=0;i<this.opposed.length;i++){
        //   tempOpposedName.push(this.opposed[i].name)
        // }
        // var tempManageName = []
        // for(var i=0;i<this.content.manager;i++){
        //   if(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]})){
        //     tempManageName.push(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]}).name)
        //   }
        // }
        // this.reconciliation.caseNumber = this.content.caseNumber
        // this.reconciliation.clientName = tempClientName.toString()
        this.reconciliation.panel = true
      },
      //开票
      invoiceState:function(){
        // var tempClientName = []
        // var tempClientAddress = []
        // var tempOpposedName = []
        // for(var i=0;i<this.client.length;i++){
        //   tempClientName.push(this.client[i].name,)
        //   tempClientAddress.push(this.client[i].address,)
        // }
        // for(var i=0;i<this.opposed.length;i++){
        //   tempOpposedName.push(this.opposed[i].name)
        // }
        // var tempManageName = []
        // for(var i=0;i<this.content.manager;i++){
        //   if(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]})){
        //     tempManageName.push(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]}).name)
        //   }
        // }
        // this.invoice.caseNumber = this.content.caseNumber
        // this.invoice.clientName = tempClientName.toString()
        this.invoice.panel = true
      },
      //提成
      editState:function(){
        var tempClientName = []
        var tempClientAddress = []
        var tempOpposedName = []
        // for(var i=0;i<this.client.length;i++){
        //   tempClientName.push(this.client[i].name,)
        //   tempClientAddress.push(this.client[i].address,)
        // }
        // for(var i=0;i<this.opposed.length;i++){
        //   tempOpposedName.push(this.opposed[i].name)
        // }
        // var tempManageName = []
        // for(var i=0;i<this.content.manager;i++){
        //   if(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]})){
        //     tempManageName.push(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]}).name)
        //   }
        // }
        // this.edit.caseNumber = this.content.caseNumber
        // this.edit.clientName = tempClientName.toString()
        this.edit.panel = true
      },
    },
    computed:{
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
    },
    mounted:function () {
      this.getTrackingStateList()
      this.getProjcetList()
    }
  }
</script>
